export default __webpack_public_path__ + "static/media/Ellipse.657a1493.svg";